import {ReactElement} from "react";
import {Image} from "antd";
import IClient from "../interfaces/IClient";

interface IProps {
    client: IClient
    size?: number
}

export default function ClientIcon(props: IProps): ReactElement | null {
    const icon = `${window.userprofile.url}/${window.userprofile.path.icon}/${props.client?.logo ?? "la"}.png`;
    document.querySelector("link[rel=icon]")?.setAttribute("href", icon);
    return (
        <Image onClick={(event) => (event.target as Element).classList.toggle("inverse")} className={"logo-"+props.client?.id} preview={false} src={icon}/>
    )
}